import * as userRestActions from './rest.actions'
import * as userSocketsActions from './sockets.actions'

export default { userRestActions, userSocketsActions }
